import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TIMEZONE_OPTIONS } from '@navstation-portal/shared/util/time';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';
import { TrashButtonComponent } from '../trash-button/trash-button.component';
import { LatLongTemplateComponent } from '../../shared/lat-long-template/lat-long-template.component';

@Component({
  selector: 're-position-report',
  templateUrl: './position-report.component.html',
  styleUrl: './position-report.component.css',
  imports: [
    FormsModule,
    ReorderButtonsComponent,
    TrashButtonComponent,
    LatLongTemplateComponent,
  ],
})
export class PositionReportComponent {
  protected readonly timezoneOptions = TIMEZONE_OPTIONS;

  @Input({ required: true }) action: any;

  @Output() delete = new EventEmitter<any>();
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();

  onDelete() {
    this.delete.emit(this.action);
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }
}
